export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <div className="w-16 h-16 mx-auto mb-6 rounded-2xl flex items-center justify-center bg-primary-100 text-primary-500">
            <i className="ri-mail-send-line text-2xl"></i>
          </div>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3" style={{ fontFamily: "var(--font-heading)" }}>
            联系我们
          </h2>
          <p className="text-sm text-foreground-500 mb-8 leading-relaxed max-w-xl mx-auto">
            如果你有好的影视资源推荐、合作意向或任何问题反馈，欢迎通过以下方式联系我们。
            桃子视频团队期待与每一位影迷朋友交流，共同打造更好的观影体验。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="mailto:hello@peachvideo.example.com"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-white font-medium text-sm whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors"
            >
              <i className="ri-mail-line text-lg"></i>
              发送邮件
            </a>
            <a
              href="#faq"
              onClick={(e) => {
                e.preventDefault();
                const el = document.querySelector('#faq');
                if (el) el.scrollIntoView({ behavior: 'smooth' });
              }}
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full border border-foreground-200 text-foreground-700 font-medium text-sm whitespace-nowrap cursor-pointer hover:bg-background-200 transition-colors"
            >
              <i className="ri-question-line text-lg"></i>
              查看常见问题
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}